import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import Skill from "./components/pages/Skill";
import AttributeCalculator from "./components/pages/AttributeCalculator";

export default function Routes() {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/" exact component={Skill} />
                <Route path="/shared-build/:build" exact component={Skill} />
                <Route path="/attribute-calculator" exact component={AttributeCalculator} />
            </Switch>
        </BrowserRouter>
    );
}
